import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../../../assets/images/chat/edit-pencil-grey.svg'
import _imports_1 from '../../../../../assets/images/chat/muted-bell.svg'


const _hoisted_1 = { class: "me-2 d-block d-md-none" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ms-2" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mb-0 black-text fw-semibold"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-0 black-text fw-semibold"
}
const _hoisted_8 = {
  key: 2,
  class: "mb-0 black-text weight-600"
}
const _hoisted_9 = {
  key: 3,
  class: "mb-0 black-text fw-semibold"
}
const _hoisted_10 = {
  key: 5,
  class: "edit-group-name"
}
const _hoisted_11 = { class: "font-size-sm" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Group name ")
const _hoisted_13 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-2" }, null, -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "field-invalid my-1"
}
const _hoisted_17 = { class: "d-flex justify-content-end" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "spinner-border spinner-border-sm" }
const _hoisted_20 = {
  key: 0,
  class: "conversation-users"
}
const _hoisted_21 = {
  key: 1,
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_22 = { class: "conversation-users black-text fw-semibold" }
const _hoisted_23 = {
  key: 2,
  class: "muted-text"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"0.9rem"},
  src: _imports_1
}, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, " Muted", -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "ms-auto d-flex align-items-center" }
const _hoisted_28 = {
  class: "dropdown-menu py-1",
  "aria-labelledby": "Chat-Options"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _component_AudioVideoConferencing = _resolveComponent("AudioVideoConferencing")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_alphanumeric_dash_space_only = _resolveDirective("alphanumeric-dash-space-only")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routeBacktoConnect && _ctx.routeBacktoConnect(...args)))
      }, _hoisted_3)
    ]),
    _createVNode(_component_AvaInitials, {
      initialsType: _ctx.activeConversation?.conversationType,
      user: _ctx.getUser(_ctx.activeConversation?.loginIds[0]),
      showStatus: _ctx.activeConversation?.isDraftConversation ? false : true,
      isDraftConv: _ctx.activeConversation?.isDraftConversation
    }, null, 8 /* PROPS */, ["initialsType", "user", "showStatus", "isDraftConv"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.activeConversation?.title?.length > 0)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_6, _toDisplayString(_ctx.activeConversation?.title), 1 /* TEXT */))
          : (_ctx.activeConversation?.loginIds.length)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.formatConversationTitle(_ctx.activeConversation?.loginIds, 100)), 1 /* TEXT */))
            : (_ctx.activeConversation?.isDraftConversation)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_8, "New Chat"))
              : (_openBlock(), _createElementBlock("h6", _hoisted_9, "Just You")),
        (
                    _ctx.activeConversation?.conversationType == _ctx.ConversationTypeEnum.GroupConversation &&
                    !_ctx.activeConversation?.hasUserLeftChat &&
                    !_ctx.showCallHeader.show
                )
          ? (_openBlock(), _createElementBlock("img", {
              key: 4,
              class: "cursor-pointer ps-2",
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEditGroupNameClick && _ctx.handleEditGroupNameClick(...args)))
            }))
          : _createCommentVNode("v-if", true),
        (
                    _ctx.activeConversation?.conversationType == _ctx.ConversationTypeEnum.GroupConversation &&
                    _ctx.showEditGroupPopup &&
                    !_ctx.activeConversation?.hasUserLeftChat
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _hoisted_12,
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, _hoisted_15)), [
                  [_directive_custom_popover, { content: _ctx.groupNameTooltip, className: 'info-popup' }]
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control mt-1", `${!_ctx.v$.newGroupName.$error ? ' mb-3' : 'field-invalid'}`]),
                placeholder: "Enter group name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newGroupName) = $event)),
                maxlength: "250",
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.newGroupName.$touch && _ctx.v$.newGroupName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newGroupName],
                [_directive_focus],
                [_directive_alphanumeric_dash_space_only]
              ]),
              (_ctx.v$.newGroupName.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Group name is required."))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "btn btn-light border border-secondary me-2",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel()))
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "btn btn-primary border border-primary",
                  disabled: _ctx.isSavingGroupName || !_ctx.isNameUpdated,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateGroupName()))
                }, [
                  _withDirectives(_createElementVNode("span", _hoisted_19, null, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.isSavingGroupName]
                  ]),
                  _createTextVNode(" " + _toDisplayString(!_ctx.isSavingGroupName ? "Save" : "Saving.."), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_18)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.activeConversation?.title?.length > 0 && !_ctx.activeConversation.isMuted)
        ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.visibleList), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.hiddenCount > 0 && !_ctx.activeConversation.isMuted)
        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, "+ " + _toDisplayString(_ctx.hiddenCount), 1 /* TEXT */)
          ])), [
            [_directive_custom_popover, { content: _ctx.hiddenList }]
          ])
        : _createCommentVNode("v-if", true),
      (_ctx.activeConversation.isMuted)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_26))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_AudioVideoConferencing, { "room-name-template": _ctx.roomNameTemplate }, null, 8 /* PROPS */, ["room-name-template"]),
      _createElementVNode("div", null, [
        (!_ctx.activeConversation?.isAxxessConversation)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(`fas fa-ellipsis-h font-size-lg ms-1 ms-md-3 pt-1 ps-md-1 cursor-pointer chat-options-btn ${
                    _ctx.isCallOngoing ? 'text-white' : ''
                }`),
              "data-bs-toggle": "dropdown"
            }, null, 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_28, [
          (!_ctx.activeConversation?.isDraftConversation)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "dropdown-item font-size-sm bulk-reassign",
                href: "javascript:void(0);",
                id: "view-shared-files",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.viewSharedFiles && _ctx.viewSharedFiles(...args)))
              }, " View Shared Files "))
            : _createCommentVNode("v-if", true),
          _createElementVNode("a", {
            class: "dropdown-item font-size-sm",
            href: "javascript:void(0);",
            id: "delete-conversation",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteConversation && _ctx.deleteConversation(...args)))
          }, " Delete "),
          (!_ctx.activeConversation?.hasUserLeftChat && !_ctx.activeConversation?.isDraftConversation)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "dropdown-item font-size-sm",
                href: "javascript:void(0);",
                id: "mute-conversation",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleMute && _ctx.toggleMute(...args)))
              }, _toDisplayString(_ctx.activeConversation.isMuted ? "Unmute" : "Mute") + " Chat ", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}